import { useQuery } from "@tanstack/react-query";

interface PublicMarketConfig {
  enabled: boolean;
}

/**
 * Reads the public CV-vs-market feature flag from the ungated
 * `/api/config/public-market` probe so marketing surfaces can decide
 * whether to render promo links. Defaults to hidden (false) until the
 * probe resolves, so a dark feature is never advertised.
 */
export function usePublicMarketEnabled(): boolean {
  const { data } = useQuery<PublicMarketConfig>({
    queryKey: ["/api/config/public-market"],
    // Kill-switch posture: re-check on every mount/focus so flipping the
    // flag off propagates quickly and we never advertise a dark feature.
    // The probe is a trivial boolean env read, so frequent refetches are cheap.
    staleTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });

  return data?.enabled ?? false;
}
